import React from 'react';
import { Col, Card } from 'react-bootstrap';

const Special = ({ special }) => {
    return (
        <Col className="mx-auto">
            <Card>
                <Card.Img className="special-img" variant="top" src={special.url} />
                <Card.Body>
                    <Card.Title>{special.title}</Card.Title>
                    <Card.Text>
                        {special.description}
                    </Card.Text>
                </Card.Body>
            </Card>
        </Col>
    );
};

export default Special;